import { connect } from 'react-redux';
import UpdatePoliticaCobranca from './updatePoliticaCobranca';

export default connect()(UpdatePoliticaCobranca);
